export class AppBackRoutes {

    public static LOGIN_SERVICE = 'login/do_login';
    public static PERMISSION_SERVICE = 'login/get_permission';
    public static userLayoutData = 'home/user_data';
    public static dashboard_service = 'home/dashboard';
    public static profileGeneralGet = 'home/profile';
    public static profileGeneralPost = 'home/update_profile';
    public static profileUserManagement = 'home/user_management';
    public static profileUserMangSort = 'home/sorting';
    public static settingsData = 'home/settings';
    public static settingsFormMang = 'home/form_settings';
    public static settingsSettings = 'home/settings_settings';
    public static ticketList = 'ticket/list_ticket';
    public static ticketCreate = 'ticket/save_ticket';
    public static ticketView = 'ticket/view_ticket';
    public static ticketReply = 'ticket/reply_ticket';
    public static ticketClose = 'ticket/close_ticket';
    public static ticketCategories = 'ticket/ticket_category';

    //Deadlines
    public static deadlineList = 'timetable';
    public static deadlineCreate = 'timetable/deadline_timetable';
    public static deadlineView = 'timetable/view';
    public static deadlineDelete = 'timetable/timetable_delete';
    public static deadlineMultiDelete = 'timetable/delmultipletime';
    public static deadlineMultiDuplicate = 'timetable/clone_timetable';
    public static deadlineCalendar = 'timetable/get_calendar';
    public static deadlineOccurrence = 'timetable/timetable_occurrence';
    public static updatePausePlay = 'timetable/timetable_occurrence';
    public static updatePause = 'timetable/updatePause';
    public static deadlineaction = 'timetable/timetable_intervention';
    public static deadlineEditaction = 'timetable/timetable_intervention';
    public static deadlineinterDelete = 'timetable/timetable_intervention';
    public static deadlineuploadExcel = 'timetable/import_data';
    public static deadlineViewMultiDelete = 'timetable/delmultipletime_action';
    public static deadlineSorting = 'servicing/sorting';


    public static servicingList = 'servicing/index';
    public static servicingCreate = 'servicing/service_management';
    public static servicingDelete = 'servicing/delete';
    public static servicingMultiDuplicate = 'servicing/clone_servicing';
    public static servicingMultiDelete = 'servicing/delmultipleservice';
    public static servicinguploadExcel = 'servicing/import_data';


    

    public static servicingMaintenancelist = 'servicing/maintenance_plans';
    public static servicingCalendar = 'servicing/get_notis_forcal';
    public static servicingMainMultiDelete = 'servicing/servicing_maintenance';
    public static generalList = 'servicing/single_view';

    public static servicingTurnoff = 'servicing/rem_date_to_deactivateplans';
    public static active_status = 'servicing/add_date_for_activeplans';

    public static exordinary_servicing = 'servicing/exordinary_servicing';
    public static edit_extraordinary = 'servicing/edit_extra_odinary';
    public static deleteExtraordinary = 'servicing/exordinay_delete';
    public static exordinaryData = 'servicing/exordinaryData';
    public static mexordinaryData = 'measurement/exordinaryData';
    public static delete_mextraordinary = 'servicing/delmultipletime_extraordinary';
    public static multiExtraDuplicate = 'servicing/clone_extrodinary_maintenance';

    public static ordinaryData = 'servicing/ordinaryData';
    public static ordinary_servicing = 'servicing/ordinary_servicing';
    public static edit_ordinary = 'servicing/servicing_intervention_maintenance';
    public static deleteOrdinary = 'servicing/ordinay_delete';
    public static deleteMultiOrdinary = 'servicing/delmultipletime_ordinary';
    public static multiOrdDuplicate = 'servicing/clone_odinary_maintenance';

    public static statisticsSearch = 'servicing/statistics_search';
    public static mstatisticsSearch = 'measurement/statistics_searchs';
    public static mdelete_mextraordinary = 'measurement/delmultipletime_extraordinary';
    public static mexordinary_servicing = 'measurement/exordinary_measurment';
    public static medit_extraordinary = 'measurement/edit_extra_odinary';
    public static viewMeasuremntpdf = 'measurement/view_servicing_pdf';

    public static maintenancePlans = 'servicing/maintenance_plans';
    public static deleteMaintenance = 'servicing/maintenance_ajax_section';
    public static multiDeleteMaintenance = 'servicing/maintenance_ajax_section';
    public static multiDuplicateMaintenance = 'servicing/maintenance_ajax_section';

    public static getMaintenanceformdata = 'servicing/getMaintenanceformdata';
    public static update_maintenance = 'servicing/maintenance_ajax_section';
    public static editMaintenanceformdata = 'servicing/maintenance_ajax_section';
    public static getServicingList = 'servicing/service_listmanagement';
    public static check_plancode = 'servicing/maintenance_ajax_section';
    


    public static update_documents = 'servicing/service_documents';
    public static documentsData = 'servicing/service_documents';
    public static edit_documents = 'servicing/service_documents';
    public static deleteDocuments = 'servicing/service_documents';
    public static delete_msdocuments = 'servicing/service_documents';
    public static duplicate_msdocuments = 'servicing/service_documents';
    public static documentsuploadExcel = 'servicing/service_documents';


    public static notificationList = 'course/notification';
    public static NotificationGeneralGet = 'course/add_notification';
    public static NotificationCreate = 'course/save_notification';
    public static NotificationDelete = 'course/delete_notification';
    public static NotificationMultiDelete = 'course/delmultiplenoti';
    public static NotificationMultiDuplicate = 'course/clone_notification';
    public static NotificationuploadExcel = 'course/import_notification';
    public static NotificationEdit = 'course/edit_notification'; 


    public static notificationView = 'course/notification_view';
    public static NotificationViewDelete = 'course/remove_emp_notification';
    public static NotificationAddPeople = 'course/add_partecipent_notification';
    public static NotificationSendmails = 'course/send_notification';
    public static NotificationInterventionMail = 'course/intervention_mail';
    
    public static medicalExamination = 'course/medical_examination';
    public static MedicalGeneralGet = 'course/examination_view';
    public static MedicalOccurenceUpdate = 'course/medical_examination_occurrence';
    public static NewInterventionGet = 'course/new_intervention';
    

    public static employeeList = 'course/employee_list';
    public static employeeCourseDetails = 'course/view_course_details';
    public static getEmployeeList = 'course/employee_management';
    public static getdpimail = 'course/employee_management';
    public static updateMail = 'course/send_notification_emp';
    public static employeeCreate = 'course/employee_management';
    public static employee_view = 'course/employee_view';
    public static notifyList = 'course/notify_list';
    public static medicalList = 'course/medical_list';
    public static MedicalMultiDuplicate = 'course/clone_medical_exam';
    public static MedicalMultiDelete = 'course/delmultipleexlist';
    public static MedicalDelete = 'course/remove_exam';
    public static MedicalInterventionDelete = 'course/delete_intervention';
    public static MedicaluploadExcel = 'course/import_exam';
    public static newExamination = 'course/new_examination';
    public static editExaminationGet = 'course/edit_examination';
    
    public static ExaminationCreate = 'course/save_examination';
    public static ExaminationUpdate = 'course/edit_examination';
    public static employeeDelete = 'course/delete_employee';
    public static removeParticipantDelete = 'course/remove_employee';
    public static removeParticipant = 'course/remove_certificate';
    public static addParticipantDelete = 'course/add_partecipent';
    
    public static employeeMultiDelete = 'course/delmultipleemp';
    public static employeeMultiDuplicate = 'course/clone_employee';
    public static certificationSave = 'course/emp_certification';
    public static certificationDelete = 'course/emp_certification';
    public static employeeuploadExcel = 'course/import_employee';


    public static employeeHired = 'course/hired_employee';
    public static employeeResign = 'course/resigned_employee';
    public static uploadCertificate = 'course/upload_certificate';



    public static emptrainingData = 'course/emptrainingData';
    public static employeeSorting = 'servicing/sorting';

    public static updateReport = 'course/test_report';
    public static updateafdReport = 'course/add_first_device';
    public static updateatdReport = 'course/add_third_device';
    public static removeFirstDevice = 'course/remove_first_device';
    public static removeThirdDevice = 'course/remove_third_device';
    public static editFirstDevice = 'course/edit_first_device';
    public static employeeSkillsInsert = 'course/employee_skills_insert';
    public static getSkillsList = 'course/employee_skills_edit';
    public static skillsDelete = 'course/delete_employee_skills';
    public static SkillsMultiDuplicate = 'course/clone_employee_skills';
    public static skillsMultiDelete = 'course/delmultipleskills';
    public static skillsAnalysisMultiDelete = 'course/skills_analysis_multi_delete';
    public static skillsuploadExcel = 'course/import_employee_skills';
    public static getSkillEmployees = 'course/get_skill_employees';
    public static addSkillEmployees = 'course/add_skills_analysis';
    public static addSkillAnalysisDepartment = 'course/skills_analysis_department';
    
    public static skillsanalysisList = 'course/skills_analysis';
    public static courseList = 'course/create_courses';
    public static coursesEdit = 'course/create_courses';
    public static updateCourse = 'course/create_course';
    public static search_course = 'course/search_course';
    public static coursesUpdateOption = 'course/update_option';
    public static coursesDelete = 'course/course_delete';
    public static coursesMultiDelete = 'course/delmultiplecourse';
    public static coursesMultiDuplicate = 'course/clone_course';
    public static getProtectivedevice = 'course/get_dpithirdrecords';

    
    public static measurementList = 'measurement/index';
    public static measurementMultiDuplicate = 'measurement/clone_measurement';
    public static measurementDelete = 'measurement/delete';
    public static measurementMultiDelete = 'measurement/delete';
    public static measurementuploadExcel = 'measurement/import_data';
    public static create = 'measurement/create';
    public static updateMeasurement = 'measurement/create';
    public static measurementEdit = 'measurement/edit';
    public static cmeasurementList = 'measurement/calibration_planning';
    public static edit_mordinary = 'measurement/measurement_intervention_maintenance';

    public static mordinary_servicing = 'measurement/ordinary_servicing';
    public static calibrationMultiDelete = 'measurement/delete_maintenance';
    public static mvordinaryData = 'measurement/ordinaryData';
    public static single_view = 'measurement/msingle_view';
    public static mvactive_status = 'measurement/add_date_for_activeplans';
    public static measurementTurnoff = 'measurement/rem_date_to_deactivateplans';
    public static mvmultiOrdDuplicate = 'measurement/clone_odinary_maintenance';
    public static mvdeleteMultiOrdinary = 'measurement/delmultipletime_ordinary';

    public static calibrationPlans = 'measurement/calibration_plans';
    public static cpmultiDuplicateMaintenance = 'measurement/maintenance_ajax_section';
    public static cpmultiDeleteMaintenance = 'measurement/maintenance_ajax_section';
    public static cpdeleteMaintenance = 'measurement/maintenance_ajax_section';
    public static getMeasurementformdata = 'measurement/getMeasurementformdata';

    
    public static cpupdate_maintenance = 'measurement/maintenance_ajax_section';
    public static check_cpplancode = 'measurement/maintenance_ajax_section';
    public static editMeasurementformdata = 'measurement/maintenance_ajax_section';

    public static mdeleteExtraordinary = 'measurement/exordinay_delete';
    public static mmultiExtraDuplicate = 'measurement/clone_extrodinary_maintenance';


    public static problemsolvingList = 'problem_solving/index';
    public static psMultiDuplicate = 'problem_solving/clone_course';
    public static psMultiDelete = 'problem_solving/delmultipleproblem';
    public static problemsolvingDelete = 'problem_solving/course_delete';
    public static problemsolvinguploadExcel = 'problem_solving/import_problems';
    public static getProblemsList = 'problem_solving/getProblemsList';
    public static psingle_view = 'problem_solving/view_problem_details';
    public static problemsolvingCreate = 'problem_solving/prob_solv_management';
    public static problemsolvingEdit = 'problem_solving/prob_solv_management';
    public static update_treatment = 'problem_solving/add_treatment';
    public static update_cause = 'problem_solving/add_cause';
    public static update_corrective = 'problem_solving/add_corrective';
    public static update_check = 'problem_solving/add_check_effect';
    public static problemsolvingViewDelete = 'problem_solving/remove_mail_notification';
    public static sendMail = 'problem_solving/send_customer_attchs_action';
    public static pdfexport = 'problem_solving/view_problem_pdfexport';
    public static treatmentUnlock = 'problem_solving/update_lock_status';
    public static send_customer_attchs_changed = 'problem_solving/send_customer_attchs_changed';
    public static problemSolvingSorting = 'servicing/sorting';


    public static view_problem_pdfexport = 'problem_solving/view_problem_pdfexport';
    public static viewServicingpdf = 'servicing/view_servicing_pdf';


    public static documentmangList = 'documents_mang/index';
    public static documentMangCreate = 'documents_mang/document_manage';
    public static check_cdoccode = 'documents_mang/document_manage';
    public static getDocumentMangList = 'documents_mang/document_manage';
    public static documentMangEdit = 'documents_mang/document_manage';
    public static documentMangDelete = 'documents_mang/document_manage';
    public static documentMangMultiDelete = 'documents_mang/delmultipledocs';
    public static documentMangMultiDuplicate = 'documents_mang/document_copy';
    public static documentMangView = 'documents_mang/view';
    public static createdocmang = 'documents_mang/document_intervention';
    public static editdocmang = 'documents_mang/document_intervention';
    public static documentMangViewDelete = 'documents_mang/document_intervention';
    public static documentMangViewMultiDelete = 'documents_mang/document_intervention';
    public static document_aintervention = 'documents_mang/document_intervention';
    public static documentMangOccurrence = 'documents_mang/document_occurrence';
    public static documentsManguploadExcel = 'documents_mang/import_data';
    public static scheduledCourse = 'academy/create_schedule_course';


    public static customersList = 'customers/index';
    public static getCustomerList = 'customers/create';
    public static updateCustomer = 'customers/create';
    public static CustomerEdit = 'customers/edit';
    public static customersDelete = 'customers/delete';
    public static customersMultiDelete = 'customers/delmultiplecustomers';
    public static customersMultiDuplicate = 'customers/copy_customer_list';
    public static customersuploadExcel = 'customers/customer_import_data';

    public static csingle_view = 'customers/single_view';
    public static uploadimg = 'customers/upload_imag';
    public static employeeData = 'customers/upload_imag';
    public static updateOperating = 'customers/create_ol';
    public static editoperating = 'customers/cust_op_loc_manage';
    public static delete_operating = 'customers/operaing_delete';
    public static multiOLDuplicate = 'customers/clone_course_ol';
    public static customersOplMultiDelete = 'customers/delmultiplecourse_ol';


    public static supplyersList = 'supplyers/index';
    public static updateSupplyer = 'supplyers/create';
    public static SupplyersEdit = 'supplyers/edit';
    public static supplyersDelete = 'supplyers/delete';
    public static supplyersMultiDuplicate = 'supplyers/copy_customer_list';
    public static supplyersMultiDelete = 'supplyers/delmultiplecustomers';
    public static msingle_view = 'supplyers/single_view';
    public static mupdateOperating = 'supplyers/create_ol';
    public static meditoperating = 'supplyers/cust_op_loc_manage';
    public static sdelete_operating = 'supplyers/operaing_delete';
    public static smultiOLDuplicate = 'supplyers/clone_course_ol';
    public static scustomersOplMultiDelete = 'supplyers/delmultiplecourse_ol';
    public static suploadimg = 'supplyers/supload_imag';


    public static updateEmployee = 'customers/create_employee';
    public static delete_employee = 'customers/delete_customer_emp';
    public static cusEmpMultiDuplicate = 'customers/clone_course_emp';
    public static cusEmpMultiDelete = 'customers/delmultiplecourse_emp';
    public static editemployee = 'customers/html_data';
    public static updateEmpImport = 'customers/employee_import_data';
    public static paymentReferences = 'project/update_payment_ref';
    public static addEventConsultancy = 'consultancy/create_event';
    public static deleteEventConsultancy = 'consultancy/delete_event';

    //Start Consultancy
    public static consultancyList = 'consultancy/index';
    public static getConsultancyList = 'consultancy/create';
    public static update_consultancy = 'consultancy/edit';
    public static ConsultancyEdit = 'consultancy/edit';
    public static consultancyMultiDelete = 'consultancy/delmultiplecon';
    public static consultancyDelete = 'consultancy/delete';
    public static clsingle_view = 'consultancy/single_view';
    public static get_planning = 'consultancy/get_planning';
    public static update_planning = 'consultancy/create_planing';
    public static consultancyplaningDelete = 'consultancy/delete_planinng';
    public static multiplaningDuplicate = 'consultancy/clone_planning';
    public static multiplaningDelete = 'consultancy/delmultiplecourse';
    public static planning_html = 'consultancy/planning_html';
    public static update_task = 'consultancy/consultancy_view_task';
    public static close_task = 'consultancy/consultancy_view_task';
    public static download_task = 'consultancy/consultancy_task_report';
    public static edit_task = 'consultancy/consultancy_view_task';
    public static delete_task = 'consultancy/consultancy_view_task';
    public static multitaskDuplicate = 'consultancy/clone_course_task';
    public static multitaskDelete = 'consultancy/delmultiplecourse_task';
    public static multidocDuplicate = 'consultancy/clone_course_doc';
    public static multidocDelete = 'consultancy/delmultiplecourse_doc';
    public static delete_documents = 'consultancy/delete_documents';
    public static consultancyreportList = 'consultancy/reporting';
    public static searchReporting = 'consultancy/reporting';
    public static consultancyCalendar = 'consultancy/get_event_data';

    

    public static multiprotDuplicate = 'consultancy/clone_course_prot';
    public static multiprotDelete = 'consultancy/delmultiplecourse_prot';
    public static delete_protocols = 'consultancy/delete_protocols';
    public static update_protocol = 'consultancy/create_protocol';
    public static edit_protocol = 'consultancy/protocol_html';

    public static update_document = 'consultancy/create_documents';
    public static getDocumentList = 'consultancy/get_documents';
    public static edit_doc = 'consultancy/document_html';


    public static scheduledList = 'academy/scheduled_course';
    public static scheduledMultiDuplicate = 'academy/clone_schedule_course';
    public static scheduledMultiDelete = 'academy/delmultiplecasc';
    public static scheduledcourseDelete = 'academy/scheduled_delete';
    public static scheduledCreateList = 'academy/create_schedule_course';
    public static scheduled_course_view = 'academy/scheduled_course_view';
    public static generalLangpopup = 'academy/schedule_course_generate_test';
    public static getCatloqData    = 'academy/catalog_data';


    public static courseCatelogList = 'academy/view_catalog';
    public static coursesCatalogMultiDuplicate = 'academy/copy_course_catalog';
    public static coursesCatalogMultiDelete = 'academy/delmultiplecacc';
    public static coursesCatalogDelete = 'academy/delete_course_catalog';
    public static coursesuploadExcel = 'academy/delete_course_catalog';
    public static courseCatelogViewList = 'academy/catalog_view';
    public static preview_final_test = 'academy/preview_final_test';
    public static qualifiedTeacherList = 'academy/qualified_teacher';
    public static qualifiedTeacherMultiDuplicate = 'academy/clone_teacher';
    public static QualifiedTeacherMultiDelete = 'academy/delmultipleact';
    public static QualifiedTeacherDelete = 'academy/delete_qualified_teacher';
    public static QualifiedTeacheruploadExcel = 'academy/import_qualified_data';
    public static getCreateTeacherList = 'academy/create_teacher';
    public static updateTeacher = 'academy/create_teacher';
    public static getEditList = 'academy/edit_qualified_data';
    public static QualifiedTeacherSkillsDelete = 'academy/teacher_ajax_section';
    public static getQSkillsList = 'academy/teacher_ajax_section';
    public static qualifiedTeacherViewList = 'academy/qualified_teacher_view';
    public static QualifiedSkillsCreate = 'academy/teacher_ajax_section';
    public static QualifiedSkillsEdit = 'academy/teacher_ajax_section';

    public static addProject = 'project/create';
    public static projectList = 'project/index';
    public static projectViewList = 'project/view';
    public static updateProtocolCreate = 'project/add_protocol';
    public static ProtocolDelete = 'project/remove_protocol';
    public static ProtocolMultiDelete = 'project/delmultiplepro';
    public static protocolEdit = 'project/edit_protocol';
    public static delete_renovate = 'project/project_renovate';
    public static projectclassList = 'project/classes';
    public static ProjectClassuploadExcel = 'project/project_classes';
    public static ProjectClassMultiDelete = 'project/project_classes';
    public static ProjectClassDelete = 'project/project_classes';
    public static getProjectclassList = 'project/project_classes';
    public static updateProjectclass = 'project/project_classes';
    public static projectClassEdit = 'project/project_classes';

    public static getauditList = 'audit/index';
    public static getstandardList = 'audit/standard';
    public static updateStandard = 'audit/update_standard';
    public static updateChapter = 'audit/update_chapter';
    public static getauditDropdown = 'audit/dropdown';
    public static getStdClauseDropdown = 'audit/dropdown_clause';
    public static addAudit = 'audit/add_audit';
    public static editAudit = 'audit/edit_audit';
    public static getAuditInfo = 'audit/audit_info';
    public static generateAuditPlanReport = 'audit/audit_plan_report_generate';
    public static generateAuditReportPdf = 'audit/audit_report_generate';
    public static AuditStandardDelete  = 'audit/delete_standard';
    public static AuditClauseDelete  = 'audit/delete_clause';    
    public static generateAuditReport = 'audit/audit_plan_report_view';
    public static deleteAudit = 'audit/delete_audit';
    public static AuditUserData = 'audit/user_data';
    public static AuditSendMail = 'audit/audit_plan_mail_send';
    public static SaveAuditing = 'audit/audit_update_auditing';
    public static SaveDocsForm = 'audit/audit_update_clause';
    public static AddRemarks  = 'audit/add_remarks_content';
    public static GetDocsInfoForm = 'audit/audit_view_clause';
    public static AuditReportSendMail = 'audit/audit_report_mail_send';
    public static AuditReportSendMailDelete = 'audit/delete_audit_report_mail';
    public static AuditTriggerReortMail = 'audit/send_audit_report_mail';
    public static GetAuditStandardInfo = 'audit/standard_info';
    public static GetChapterInfo = 'audit/chapter_info';
    public static DeleteChapter = 'audit/delete_chapter';
    public static addAuditClause  = 'audit/add_clause';
    public static editAuditClause = 'audit/update_clause';
    public static ClauseInfo = 'audit/clause_info';
    

    /* Privacy Module */
    public static GetAllTreatmentList  = 'privacy/get_privacy_treatment_creation';
    public static AddTreatmentRegister = 'privacy/add_privacy_treatment_creation';
    public static DeleteTreatmentRegister = 'privacy/delete_privacy_treatment_creation';
    public static GetTreatmentList = 'privacy/privacy_treatment_creation';
    
    /*Admin Side Links Start Here*/
    public static SUPER_ADMIN = 'SuperAdmin/do_login';
    public static SPERMISSION_SERVICE = 'SuperAdmin/get_permission';


    public static adminticketList = 'ticket/admin_list_ticket';
    public static adminticketReply = 'ticket/admin_reply_ticket';
    public static adminticketClose = 'ticket/admin_close_ticket';
    public static mailConfigList = 'superadmin/mail_config';

    public static installationList = 'dashboard/installation_list';
    public static super_admin_service = 'dashboard/index';
    public static calendar_data = 'dashboard/home_cal_data';
    public static superAdminDashboard = 'dashboard/home_cal_data';
    public static super_admin_user_details = 'dashboard/user_details_id';
    public static super_admin_user_add = 'dashboard/add_installation';
    public static super_admin_user_edit = 'dashboard/edit_installation';
    public static super_admin_user_delete = 'dashboard/delete_installation';
    public static super_admin_lang_get = 'dashboard/lang_data';
    public static super_admin_lang_put = 'dashboard/update_lang';
    public static super_admin_mail_get  = 'dashboard/config_mail';
    public static super_admin_mail_post = 'dashboard/config_mail';
    public static super_admin_package_add = 'dashboard/add_package';
    public static super_admin_package_edit = 'dashboard/edit_package';    
    public static super_admin_package_delete = 'dashboard/delete_package';    
    public static super_admin_package_list = 'dashboard/package_list';
    public static super_admin_package_details = 'dashboard/package_details_id';
    /*Admin Side Links End Here*/
    
    
}
